import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const DEFAULT_LANGUAGE: Language = 'en';

export type Language = 'en' | 'es' | 'pt';
export const AVAILABLE_LANGUAGES: Language[] = ['en', 'es', 'pt'];

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translate: TranslateService = inject(TranslateService);

  constructor() {
    this.initLanguage();
  }

  initLanguage(): void {
    this.translate.addLangs(AVAILABLE_LANGUAGES);
    this.translate.setDefaultLang(DEFAULT_LANGUAGE);

    const savedLanguage: string = localStorage.getItem('lang') || DEFAULT_LANGUAGE;
    this.translate.use(savedLanguage);
  }

  setLanguage(lang: Language): void {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
  }

  getLanguage(): Language {
    const language = (localStorage.getItem('lang') as Language) || DEFAULT_LANGUAGE;
    return language;
  }
}
